import { render, staticRenderFns } from "./DataQualityDetailManager.vue?vue&type=template&id=59506f10&scoped=true"
import script from "./DataQualityDetailManager.vue?vue&type=script&lang=js"
export * from "./DataQualityDetailManager.vue?vue&type=script&lang=js"
import style0 from "./DataQualityDetailManager.vue?vue&type=style&index=0&id=59506f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59506f10",
  null
  
)

export default component.exports